import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import DataTable from '../../shared/components/DataTable';
import EmailListHeader from './components/EmailListHeader';
import useGetEmailTemplateList from './hooks/useGetEmailTemplateList';
const EmailListPage = () => {
    const { fields, data } = useGetEmailTemplateList();
    return (_jsxs(_Fragment, { children: [_jsx(EmailListHeader, {}), _jsx(DataTable, { fields: fields, data: data || [] })] }));
};
export default EmailListPage;
